import {Component, inject, Input, OnChanges} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {catchError, of, Subject, switchMap} from 'rxjs';
import {
    AggregateType,
    BlockedStockScoreAggregateDto,
    BlockedStockScoreAggregateQuery,
    IMyScoreShiftQuery,
    InventoryClient,
    SLAScoreQuery,
} from '@services';
import {DoughnutChartComponent} from '../../../components/library/doughnut-chart/doughnut-chart.component';
import {BlockedStockChartComponent} from '../../inventory/blocked-stock/blocked-stock-charts/blocked-stock-chart/blocked-stock-chart.component';
import {BlockedStockDoughnutChartComponent} from '../../inventory/blocked-stock/blocked-stock-charts/blocked-stock-doughnut-chart/blocked-stock-doughnut-chart.component';
import {
    blockedStockSeries,
    daysOnHoldSegments,
    reasonSegments,
} from '../../inventory/blocked-stock/blocked-stock-charts/blocked-stock-charts.component';
import {DashboardAccess} from '../dashboard-access';
import {DashboardCardComponent} from '../dashboard-card/dashboard-card.component';

@Component({
    selector: 'app-dashboard-inventory',
    imports: [DoughnutChartComponent, DashboardCardComponent, BlockedStockChartComponent, BlockedStockDoughnutChartComponent],
    templateUrl: './dashboard-inventory.component.html',
})
export class DashboardInventoryComponent implements OnChanges {
    @Input() from: Date;
    @Input() to: Date;

    protected access = inject(DashboardAccess);
    private inventoryClient = inject(InventoryClient);

    protected readonly AggregateType = AggregateType;
    protected readonly blockedStockSeries = blockedStockSeries();
    protected readonly daysOnHoldSegments = daysOnHoldSegments();
    protected readonly reasonSegments = reasonSegments();

    protected blockedStock: BlockedStockScoreAggregateDto[] | null = null;
    protected blockedStockRange: {startValue?: Date; endValue?: Date} = {};
    private blockedStockQuery$ = new Subject<BlockedStockScoreAggregateQuery | null>();

    constructor() {
        this.blockedStockQuery$.pipe(
            switchMap(query => query
                ? this.inventoryClient.getBlockedStockScoreAggregate(query).pipe(catchError(() => of([])))
                : of([])),
            takeUntilDestroyed(),
        ).subscribe(data => this.blockedStock = data);
    }

    protected loadMissing216 = (query: IMyScoreShiftQuery) =>
        this.inventoryClient.getSLAScore(new SLAScoreQuery({...query, storageTypeCode: '216'}));

    protected loadPutaway260 = (query: IMyScoreShiftQuery) =>
        this.inventoryClient.getSLAScore(new SLAScoreQuery({...query, storageTypeCode: '260'}));

    ngOnChanges(): void {
        if (!this.access.blockedStock)
            return;

        this.blockedStockRange = {startValue: this.from, endValue: this.to};
        this.blockedStockQuery$.next(this.from
            ? new BlockedStockScoreAggregateQuery({
                aggregateType: AggregateType.Day,
                from: this.from,
                to: this.to,
                timeZoneOffset: new Date().getTimezoneOffset(),
            })
            : null);
    }
}
